const style = theme => ({
  truncate: {
    /*  ...theme.custom.truncate,
        fontWeight: 600,
        verticalAlign: 'top', */

    fontWeight: 600,
    whiteSpace: 'normal',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
  flex: { display: 'flex' },
  textAlign: {
    textAlign: 'center',
    justifyContent: 'center',
  },
  inlineBlock: {
    display: 'inline-block',
    fontSize: 13,
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '11px',
    },
  },
  headerColumn: {
    padding: theme.spacing(1),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    border: 'none',
    backgroundColor: 'transparent',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0.5),
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0.25),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  },
  isSortable: {
    cursor: 'pointer',
  },
  tableRow: {
    verticalAlign: 'middle',
    height: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      height: theme.spacing(4),
    },
    [theme.breakpoints.down('xs')]: {
      height: theme.spacing(3.5),
    },
  },
  sortableIcon: {},
})

export default style
